/**
 * StoreBar Action Types
 */

export const FETCH_COMMON_CLUB_LIST_REQUEST = 'FETCH_COMMON_CLUB_LIST_REQUEST' as const;
export const FETCH_COMMON_CLUB_LIST_SUCCESS = 'FETCH_COMMON_CLUB_LIST_SUCCESS' as const;
export const FETCH_COMMON_CLUB_LIST_FAILURE = 'FETCH_COMMON_CLUB_LIST_FAILURE' as const;
